<template>
  <footer class="footer">
    <div class="footer__replic">
      <IconButton icon="replic" :is-active="hasReplic" />
      <div
        v-if="replic"
        class="footer__text"
        data-animation="fadeInLeft"
      >
        <BaseText v-bind="replic" />
      </div>
    </div>
    <div class="footer__actions">
      <IconButton icon="abort" @click="abortReplic" />
    </div>
  </footer>
</template>

<script>
import volumeMixin from '@/mixins/volume';
import replicMixin from '@/mixins/replic';

import IconButton from '@/components/IconButton.vue';
import BaseText from '@/components/BaseText.vue';

export default {
  name: 'TheFooter',
  mixins: [volumeMixin, replicMixin],
  components: {
    IconButton,
    BaseText,
  },
  data() {
    return {
      replicText: '',
    };
  },
  computed: {
    hasReplic() {
      return Boolean(this.replicText);
    },
    replic() {
      if (!this.hasReplic) return null;
      return {
        text: this.replicText,
        size: this.replicTextSize,
      };
    },
    replicTextSize() {
      if (this.replicText.length < 100) return '';
      if (this.replicText.length < 250) return 's';
      return 'xs';
    },
  },
  methods: {
    abortReplic() {
      this.abortRobotReplic(); // функция из миксина
    },
    onReplicUpdated(text) {
      // Этот колбек будет вызван из миксина, когда прилетит реплика
      this.replicText = text;
    },
  },
};
</script>

<style lang="stylus">
.footer
  display flex
  align-items center
  padding-left $side_padding
  padding-right @padding-left

  .screen_footer_hidden ~ &
    visibility hidden

  &__replic
    display flex
    align-items center
    max-width calc(100% - 8em)
    pointer-events none

  &__text
    flex-grow 1
    flex-basis 0
    max-width calc(100% - 1.6em)
    padding-left 1.25em
    padding-right 1.25em
    .text
      overflow hidden
      text-overflow ellipsis
      display -webkit-box
      -webkit-line-clamp 3
      -webkit-box-orient vertical

  &__actions
    position relative
    margin-left auto
    display flex
    justify-content flex-end
    pointer-events auto
    width 6.8em
</style>
